import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Pipe({
    name: 'pmUIInputErrors'
})
export class InputErrorsPipe implements PipeTransform {

    transform(value: ValidationErrors | null | undefined, displayField: string | null | undefined = null): string {
        if (!value)
            return '';          
        if (value['invalid'] === true)
            return `${displayField} is invalid.`;

        if (value['required'] === true)
            return `${displayField} is required.`;

        if (value['email'] === true)
            return `${displayField} is not valid email.`;

        if (value['pattern'] || value['mask'])
            return `${displayField} is not valid.`;      

        const properties = Object.getOwnPropertyNames(value);

        if (properties && properties.length > 0)
            return `${displayField} is ${properties[0]}!`;

        return '';
    }
}